<template>
  <VTimePicker
    :model-value="timeLimit"
    :disabled="disabled"
    :class="[
      { compact: density === 'compact', 'text-error-600': isError },
      'h-100 d-block time-input'
    ]"
    variant="input"
    hide-title
    hide-header
    :format="format"
    @update:model-value="onTimeUpdate"
  />
</template>

<script setup lang="ts">
type DensityType = 'compact' | 'default'
type TimeFormat = '24hr' | 'ampm'

interface Props {
  timeLimit: string
  disabled?: boolean
  density?: DensityType
  isError?: boolean
  format?: TimeFormat
}

interface Emits {
  (e: 'update:model-value', timeLimit: string): void
}

const { timeLimit, density = 'default', format = '24hr' } = defineProps<Props>()
const emit = defineEmits<Emits>()

function onTimeUpdate(time: string | null): void {
  if (time) {
    emit('update:model-value', time)
  }
}
</script>

<style scoped lang="scss">
.time-input {
  min-width: 0 !important;
  min-height: 0 !important;

  :deep(.v-time-picker-controls) {
    margin: 0;
    font-size: 100%;
  }

  :deep(.v-time-picker-controls__time) {
    align-items: center;
  }

  :deep(.v-time-picker-controls__time__separator) {
    width: fit-content;
    font-size: 16px;
    line-height: 1;
  }

  :deep(.v-time-picker-controls__time__field) {
    width: fit-content;

    .v-input__control {
      height: auto !important;
    }

    .v-input__details {
      display: none;
    }

    .v-field {
      width: fit-content;
      font-size: 16px !important;
      background-color: #fff;
      box-shadow: none;
    }

    .v-field__overlay {
      opacity: 0 !important;
    }

    .v-field__input {
      min-height: 0 !important;
      width: 2.5ch;
      flex: unset;
    }
  }
}

.compact {
  :deep(.v-time-picker-controls__ampm) {
    display: none;
  }
}
</style>
